import { api } from '@/utils/api';
import { sanitizePathParam } from '@/utils/sanitize';
import {
	HydraulicProfile,
	HydraulicProfileDetails,
	HydraulicProfileResponse,
	HydraulicProfileUploadData,
} from './HydraulicProfiler';

export default class HydraulicProfilerRepository {
	async getAllProfiles(locationId: number): Promise<HydraulicProfile[]> {
		const lid = sanitizePathParam(locationId);
		const response = await api.get(`hydraulicprofiler/profiles/location/${lid}`);
		return response.data;
	}

	async getAllProfilesPagination(
		page: number,
		size: number,
		name?: string,
		locationId?: number,
	): Promise<HydraulicProfileResponse> {
    const params = {
      page: page,
      limit: size,
      ...name && { profileName: name },
      ...locationId && { locationIds: locationId },
    };
		const response = await api.get(
			`hydraulicprofiler/profiles/`,
			{
        params,
      }
		);
		return response.data;
	}

	async getProfileDetails(profileId: number, startDate: string, endDate: string): Promise<HydraulicProfileDetails | null> {
		const pid = sanitizePathParam(profileId);
		const response = await api.get(`hydraulicprofiler/profiles/profile/${pid}`,{
		params: {
		 		startDate,
		 		endDate,
		 	}
		 });
		const data = response.data[0];
		return data ?? null;
	}

	async deleteProfile(profileId: number): Promise<boolean> {
		const pid = sanitizePathParam(profileId);
		const response = await api.delete(`hydraulicprofiler/profiles/${pid}`);
		return response.data;
	}

	async uploadProfile(profile: HydraulicProfileUploadData): Promise<boolean> {
		const response = await api.post(`hydraulicprofiler/profiles`, profile);
		return response.data;
	}
}
